import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/api';
import { useState, useEffect } from 'react';

export const ProtectedRoute = ({ children, redirectTo = '/admin' }) => {
  const [isAuth, setIsAuth] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      const authStatus = await isAuthenticated();
      setIsAuth(authStatus);
    };
    checkAuth();
  }, []);

  if (isAuth === null) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#C6FF00] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!isAuth) {
    return <Navigate to={redirectTo} replace />;
  }
  
  return children;
};